<div class="label_properties">
  <small class="debug">{{me}}</small>
  @if (dynamicsInitialized) {
    <div>
      <mat-form-field>
        <mat-label>{{'general.sampleWebSites' | transloco}}</mat-label>
        <mat-select (selectionChange)="onSelectedShipTo($event)" [(value)]="selectedShipTo">
          @for (item of sampleSites; track item) {
            <mat-option [value]="item">{{item.name}}</mat-option>
          }
        </mat-select>
      </mat-form-field>
      <dynamic-form [fields]="uiConfigInit" (submit)="submit($event)">
      </dynamic-form>
      <br/>
      <br/>
      <button style="margin: 8px" (click)="openCors()" mat-flat-button>
        <mat-icon>lightbulb</mat-icon>
        {{'general.importantNotes' | transloco}}
      </button>
      <br/>
      <br/>
      <br/>
      <br/>
      <br/>
      <br/>
    </div>
  }
</div>
